const common = { fontFamily: "Lato", fontStyle: "normal" };
const body2 = {
  ...common,
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px"
};
const emphasized2 = {
  ...common,
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "20px",
  letterSpacing: "0.25px"
};
const caption = {
  ...common,
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "16px",
  letterSpacing: "0.4px"
};
const labelStyles = {
  body2,
  emphasized2,
  caption,
  "caption-bold": { ...caption, fontWeight: 700 },
  "body2-bold": { ...body2, fontWeight: 700 }
};
export {
  labelStyles
};
